module.exports = __webpack_public_path__ + "img/Personality test Icon - charcoal.8d5d53cd.svg";